import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { SearchSharedModule } from '../search-shared.module';
import { FreightlancerSearchFiltersDriversComponent } from './filters-drivers/freightlancer-search-filters-drivers.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    SearchSharedModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [FreightlancerSearchFiltersDriversComponent],
  exports: [FreightlancerSearchFiltersDriversComponent],
})
export class FreightlancerSearchSharedModule {}
